module.exports = __webpack_public_path__ + "static/parade-2020-house18-d61f180f7aa7a31f6c4a846cdc32f2df.jpg";